// extracted by css-extract-rspack-plugin
export default {"root":"kGjgh","wrapper":"FJwyK","section":"NuCEV","input":"la9hg","inputWithLeftSection":"SHaz_"};